import styled from 'styled-components';

import { Tabs, TooltipNewIcon, ToolTip } from '@libs/components';

import { FavoriteAssetIndicator } from 'src/components';

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const AssetDescriptionWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 1.6rem;

  ${({ theme }) => theme.media.laptop`
    padding: 0 2.4rem;
  `}
`;

export const AssetIcon = styled.img`
  width: 4rem;
  height: 4rem;

  margin-left: 1.2rem;
  margin-right: 0.8rem;
`;

export const AssetWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const AssetTitleDescWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const AssetTitleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0.4rem;
`;

export const CmcRatingWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;

  padding: 0.2rem 1.2rem;

  border-radius: ${({ theme }) => theme.borderRadius.x4};
  background-color: ${({ theme }) => theme.colors.surface.interactiveDefault};
`;

export const CustomToolTipIcon = styled(TooltipNewIcon)`
  width: 2rem;
  transform: rotate(180deg);
`;

export const AssetBalanceWrapper = styled.div`
  display: flex;
  flex-direction: column;

  align-items: flex-end;
  gap: 1rem;
`;

export const Separator = styled.div`
  width: 100%;
  height: 0.1rem;
  background-color: ${({ theme }) => theme.colors.borders.default};
  margin: 2.4rem 0;

  ${({ theme }) => theme.media.laptop`
      width: calc(100% - 4.8rem);
      margin:2.4rem auto;
  `}
`;

export const ChartWrapper = styled.div`
  height: 20.8rem;
  margin-bottom: 0.8rem;
  margin-top: 3.6rem;
  touch-action: none;

  ${({ theme }) => theme.media.laptop`
      touch-action: unset;
  `};
`;

export const CustomTabs = styled(Tabs)`
  height: 3.4rem;
  .tab-highlighter {
    height: 2.6rem;
  }
`;

export const TabsWrapper = styled.div`
  padding: 0 1.6rem;
  ${({ theme }) => theme.media.laptop`
     padding:0 2.4rem;
  `}
`;

export const CustomFavoriteAssetIndicator = styled(FavoriteAssetIndicator)`
  height: 4.4rem;
  margin: 2.2rem 1.6rem 0;
  width: unset;
`;
export const FavoriteAssetMobileWrapper = styled.div`
  ${({ theme }) => theme.media.laptop`
      display: none;
  `}
`;

export const FavoriteAssetLaptopWrapper = styled.div`
  display: none;
  ${({ theme }) => theme.media.laptop`
      display: block;
  `};
`;

export const CustomTooltip = styled(ToolTip)`
  .desc {
    color: ${({ theme }) => theme.colors.text.secondary};
  }
  .tooltipbox {
    position: absolute;
    top: calc(100% - 2.3rem);
    left: -19.3rem;
    display: none;
    background-color: transparent;
    padding-top: 3.8rem;
    min-width: 30rem;
    width: 100%;
    z-index: ${({ theme }) => theme.zIndex.medium};
  }
  .tooltip {
    border-radius: ${({ theme }) => theme.borderRadius.x2};
    &:after {
      border-bottom-right-radius: 0.4rem;
      bottom: calc(100% - 0.85rem);
      height: 1.7rem;
      width: 1.7rem;
      right: unset;
      left: 19.2rem;
      top: unset;
      border-bottom: none;
      border-right: none;
      border-top: 0.1rem solid #d5dce5;
      border-left: 0.1rem solid #d5dce5;
    }
  }
  svg {
    transform: rotate(180deg);
    width: 100%;
    height: 100%;
  }
  margin-right: 0.5rem;
  margin-bottom: 0.3rem;
  height: 1.6rem;
  width: 1.6rem;

  ${({ theme }) => theme.media.laptop`
    .tooltipbox {
        left: -2.3rem;
    }
    .tooltip:after {
      left: 2.1rem;
    }
  `}
`;
